<template>
  <output
    class="alert"
    :class="extraClasses"
  >
    <slot />
  </output>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    type: {
      type: String,
      default: 'error',
    },
    size: {
      type: String,
      default: 'md',
    },
    block: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    extraClasses() {
      return [
        this.block ? 'alert--block' : '',
        `alert--${this.size}`,
        `alert--${this.type}`,
      ];
    },
  },
};
</script>

<style scoped>
.alert {
  display: inline-block;
  border-radius: var(--border-radius-regular, 4px);
}

.alert--block {
  display: block;
}

.alert--md {
  padding: var(--size-1-4, 4px) var(--size-1, 16px);
  font-size: var(--text-sm, 14px);
}
.alert--lg {
  padding: var(--size-1-2, 8px) var(--size-1, 16px);
  font-size: var(--text-md, 16px);
}

.alert--error {
  color: var(--color-error-dark, #ff381e);
  font-weight: 600;
  background-color: var(--color-error-lightest, #ffd8d4);
}

.alert--warning {
  color: var(--color-warning-dark, #cb5e01);
  font-weight: 600;
  background-color: var(--color-warning-lightest, #ffe9d4);
}

.alert--success {
  color: var(--color-success-dark, #46ad20);
  font-weight: 600;
  background-color: var(--color-success-lightest, #dceed2);
}

.alert--info {
  color: var(--color-info-dark, #0940a1);
  font-weight: 600;
  background-color: var(--color-info-lightest, #d3e0ff);
}

input + .alert {
  margin-top: var(--size-1-2, 8px);
}
</style>
